export function combineConsumers(store, consumers) {
  Object.keys(consumers).forEach(key => {
    consumers[key](store);
  });
}

const defaultMapStateToProps = state => ({ state });
const defaultMapDispatchToProps = dispatch => ({ dispatch });
const defaultSelector = state => state;
const defaultFilter = state => true;
const argOrDefault = (arg, defaultArg) => (arg == null ? defaultArg : arg);

export function connectConsumer(
  mapStateToProps,
  mapDispatchToProps,
  selector,
  filter
) {
  mapStateToProps = argOrDefault(mapStateToProps, defaultMapStateToProps);
  mapDispatchToProps = argOrDefault(
    mapDispatchToProps,
    defaultMapDispatchToProps
  );
  selector = argOrDefault(selector, defaultSelector);
  filter = argOrDefault(filter, defaultFilter);

  function observeStore(store, select, onChange) {
    let currentState;

    function handleChange() {
      let state = select(store.getState());
      if (!filter(state)) {
        currentState = state;
        return;
      }
      if (state !== currentState) {
        currentState = state;
        onChange(currentState);
      }
    }

    let unsubscribe = store.subscribe(handleChange);
    handleChange();
    return unsubscribe;
  }

  return logic => store => {
    observeStore(store, selector, state => {
      const props = {
        ...mapStateToProps(state),
        ...mapDispatchToProps(store.dispatch),
      };
      logic(props);
    });
  };
}






// WEBPACK FOOTER //
// ./src/modules/redux-consumer/index.js